export const ValidationValueTypes: { [strategy: number]: { key: string; value: string; }[] } = {
    1: [
        { key: 'average', value: 'Average' },
        { key: 'interpolated', value: 'Interpolated' },
        { key: 'reconciled-value', value: 'Reconciled' }
    ],
    2: [
        { key: 'average', value: 'Average' },
        { key: 'reconciled-value', value: 'Reconciled' }
    ]
};